/**
 * Created by Sukh on 13/11/2017.
 */
import ScrollManager from "./../../helpers/ScrollManager"
import ProfileApi from './../../api/Profile'
import _ from 'lodash'
export default {
  watch: {
    '$route': {
      handler() {
        let self = this;
        self.initMounted();
      }, immediate: false
    }
  },
  data () {
    return {
      scrollElement: null,
      items: [],
      initialLoad: true,
      isLoading: true,
      isFinished: false,
      params: {
        user_id: "",
        type: "",
        page: 1,
        page_size: 15,
      }
    }
  },
  methods: {
    loadItems() {
      let self = this;
      self.isLoading = true;
      if (self.isFinished !== true) {
        ProfileApi.getFollowers(self.params).then((response) => {
          self.$nextTick(function () {
            let callback = response.data;
            if (!_.isEqual(self.items, callback)) {
              self.items.push.apply(self.items, callback);
            }
            self.initialLoad = false;
            self.isLoading = false;
            if (callback.length === 0) {
              self.isFinished = true;
            } else {
              self.params.page++;
            }
          }, 1);
        })
      }
    },
    initMounted() {
      let self = this;
      self.params.type = self.followType;
      let profileUrl = self.$route.params.profileUrl.split('.'),
        profileUserId = profileUrl.pop();

      if(self.profile) {
        self.params.user_id = self.profile.user_id;
      }


      self.loadItems();
    },
    onScroll() {
      let self = this;
      if (ScrollManager.isElementInViewport(document.getElementById('infiniteScrollDetector'))) {
        if (self.isFinished === true || self.isLoading === false) {
          self.loadItems();
        }
      }
    }
  },
  computed: {
    followType () {
      let self = this;
      return self.$route.name === 'ProfileFollowers' ? 'followers' : 'following';
    },
    hasItems() {
      let self = this;
      return self.items.length !== 0;
    },
  },
  mounted () {
    let self = this;
    self.scrollElement = document.getElementsByClassName('main-content')[0];
    self.scrollElement.addEventListener('scroll', self.onScroll);
    self.initMounted();
  },
  beforeDestroy() {
    let self = this;
    if (self.scrollElement !== null) {
      self.scrollElement.removeEventListener('scroll', self.onScroll);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ProfileFollowerMixin/index.js